module.exports = __webpack_public_path__ + "static/media/camera_pic.213d7d32.svg";